/**
 * mc-sb-conf.js — Confraria Zot & Straffe: inscricao -> Reportana
 * (task 0043 · emenda E1 — modelo OFICIAL de captura da Reportana)
 *
 * PORTEIRO do formulario — o TRANSPORTE e do SDK da Reportana (embed
 * colado no setting da section; o form carrega data-rptn-form e os campos
 * data-rptn-field). Este arquivo:
 *   - revela o form (sem JS, o <noscript> honesto fica no lugar — DP-7)
 *   - valida (DP-5): name >=3 pos-trim; email regex; phone >=10 digitos;
 *     consentimento marcado. Submit INVALIDO e bloqueado ANTES do SDK
 *     (preventDefault + stopImmediatePropagation) — lead sujo nao sai.
 *   - submit valido SEGUE para o SDK (nao chama preventDefault) com
 *     anti-duplo-submit (estado enviando trava novo submit).
 *   - sucesso: a Reportana redireciona de volta com ?sb_conf=ok
 *     (configurado no painel dela) => painel success_* no lugar do form.
 *   - stall: sem resposta/redirect em 10s => painel error_* (com CTA de
 *     contato) + retry livre. Honesto: nao afirma falha do lead, afirma
 *     que o envio nao foi confirmado.
 *   - telemetria SEM PII (DP-6): sb_conf_submit / sb_conf_success /
 *     sb_conf_error (conf_status: 'stall').
 *   - a11y dinamica: aria-invalid, foco no 1o invalido / paineis, live
 *     region que so anuncia textos vindos de settings ja no DOM.
 *
 * LGPD: nenhum dado do formulario vai a dataLayer, console ou storage.
 * O consentimento nao tem data-rptn-field — o SDK nao o envia (DP-6c).
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var STALL_MS = 10000;
  var SUCCESS_PARAM = 'sb_conf';
  var SUCCESS_VALUE = 'ok';

  function track(eventName, status) {
    try {
      // padrao GTM: semear o array garante o evento mesmo se este script
      // rodar antes do snippet do GTM (0037) — que herda o pre-seed
      window.dataLayer = window.dataLayer || [];
      var data = { event: eventName };
      if (status !== undefined) data.conf_status = status;
      window.dataLayer.push(data);
    } catch (e) {
      /* telemetria nunca quebra o form */
    }
  }

  function successInUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(SUCCESS_PARAM) === SUCCESS_VALUE;
    } catch (e) {
      return false;
    }
  }

  function setup(wrap) {
    // guarda de re-init: script incluido 2x ou re-render nao duplica listeners
    if (wrap.hasAttribute('data-sb-conf-ready')) return;
    wrap.setAttribute('data-sb-conf-ready', '');

    var inner = wrap.querySelector('[data-sb-conf-inner]');
    var form = wrap.querySelector('[data-sb-conf]');
    if (!inner || !form) return;

    inner.hidden = false;

    var live = wrap.querySelector('[data-sb-conf-live]');
    var errPanel = wrap.querySelector('[data-sb-conf-errpanel]');
    var okPanel = wrap.querySelector('[data-sb-conf-ok]');
    var submitBtn = form.querySelector('[data-sb-submit]');
    var submitLabel = form.querySelector('[data-sb-submit-label]');
    var spinner = form.querySelector('[data-sb-spinner]');
    var idleLabel = submitLabel ? submitLabel.textContent : '';
    var sendingLabel = (submitBtn && submitBtn.getAttribute('data-sending-label')) || idleLabel;
    var sending = false;
    var stallTimer = null;

    function announce(text) {
      if (!live) return;
      live.textContent = '';
      live.textContent = text || '';
    }

    // sucesso: volta do redirect da Reportana (?sb_conf=ok)
    if (successInUrl()) {
      form.hidden = true;
      if (errPanel) errPanel.hidden = true;
      if (okPanel) {
        okPanel.hidden = false;
        okPanel.focus();
        var okTitle = okPanel.querySelector('b');
        announce(okTitle ? okTitle.textContent : '');
      }
      track('sb_conf_success');
      // limpa o param da URL: refresh/compartilhamento nao re-exibe o painel
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete(SUCCESS_PARAM);
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (e) {
        /* URL/replaceState indisponiveis: sem efeito */
      }
      return;
    }

    var fields = {
      name: {
        el: form.querySelector('[data-sb-field="name"]'),
        valid: function (el) { return el.value.trim().length >= 3; }
      },
      email: {
        el: form.querySelector('[data-sb-field="email"]'),
        valid: function (el) { return EMAIL_RE.test(el.value.trim()); }
      },
      phone: {
        el: form.querySelector('[data-sb-field="phone"]'),
        valid: function (el) { return el.value.replace(/\D/g, '').length >= 10; }
      },
      consent: {
        el: form.querySelector('[data-sb-field="consent"]'),
        valid: function (el) { return el.checked; }
      }
    };

    function errEl(key) {
      return wrap.querySelector('[data-sb-err-for="' + key + '"]');
    }

    function setFieldError(key, hasError) {
      var f = fields[key];
      var msg = errEl(key);
      if (!f || !f.el) return;
      if (hasError) {
        f.el.setAttribute('aria-invalid', 'true');
        if (msg) msg.hidden = false;
      } else {
        f.el.removeAttribute('aria-invalid');
        if (msg) msg.hidden = true;
      }
    }

    // corrigir o campo limpa o erro no proprio input (§3.4)
    Object.keys(fields).forEach(function (key) {
      var f = fields[key];
      if (!f.el) return;
      var evt = key === 'consent' ? 'change' : 'input';
      f.el.addEventListener(evt, function () {
        if (f.valid(f.el)) setFieldError(key, false);
      });
    });

    function validateAll() {
      var firstInvalid = null;
      var firstErrText = '';
      Object.keys(fields).forEach(function (key) {
        var f = fields[key];
        if (!f.el) return;
        var ok = f.valid(f.el);
        setFieldError(key, !ok);
        if (!ok && !firstInvalid) {
          firstInvalid = f.el;
          var msg = errEl(key);
          firstErrText = msg ? msg.textContent : '';
        }
      });
      return { firstInvalid: firstInvalid, firstErrText: firstErrText };
    }

    function setSending(on) {
      sending = on;
      if (submitBtn) submitBtn.disabled = on;
      if (submitLabel) submitLabel.textContent = on ? sendingLabel : idleLabel;
      if (spinner) spinner.hidden = !on;
      form.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function onStall() {
      stallTimer = null;
      track('sb_conf_error', 'stall');
      setSending(false);
      if (errPanel) {
        errPanel.hidden = false;
        errPanel.focus();
        var title = errPanel.querySelector('b');
        announce(title ? title.textContent : '');
      }
    }

    // porteiro: registrado direto no form — roda antes de qualquer handler
    // delegado no document (SDK). Invalido => para tudo; valido => segue.
    form.addEventListener('submit', function (e) {
      if (sending) {
        // anti-duplo-submit enquanto o SDK trabalha
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      var v = validateAll();
      if (v.firstInvalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        v.firstInvalid.focus();
        announce(v.firstErrText);
        return;
      }

      // valido: NAO chama preventDefault — o SDK da Reportana assume o envio
      setSending(true);
      if (errPanel) errPanel.hidden = true;
      track('sb_conf_submit');
      if (stallTimer) clearTimeout(stallTimer);
      stallTimer = setTimeout(onStall, STALL_MS);
    });
  }

  // ── Emenda E2: stepper de vagas do modo produto ─────────────────────────
  // Conveniencia pura: o <input type=number> funciona sozinho sem JS e o
  // POST /cart/add + return_to=/checkout e nativo. Aqui so os botoes +/−,
  // com clamp em min/max (max = estoque, vindo do Liquid).
  function setupStepper(el) {
    if (el.hasAttribute('data-sb-stepper-ready')) return;
    el.setAttribute('data-sb-stepper-ready', '');

    var input = el.querySelector('input[type="number"]');
    if (!input) return;

    function clamp(n) {
      var min = parseInt(input.min, 10);
      var max = parseInt(input.max, 10);
      if (isNaN(n)) n = isNaN(min) ? 1 : min;
      if (!isNaN(min) && n < min) n = min;
      if (!isNaN(max) && n > max) n = max;
      return n;
    }

    el.querySelectorAll('[data-sb-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-sb-step'), 10) || 0;
        input.value = clamp((parseInt(input.value, 10) || 0) + delta);
      });
    });

    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10));
    });
  }

  function init() {
    document.querySelectorAll('[data-sb-stepper]').forEach(setupStepper);
    var wraps = document.querySelectorAll('[data-sb-conf-form]');
    if (!wraps.length) return;
    wraps.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
